<template style="height: 100%;">
  <div class="ExmCon">

    <el-dialog :title="$t('original.languages184')" :visible.sync="dialogTableVisible" width="38%">
      <div style="margin: 40px;">
        <table  style="border-radius: 18px;width: 100%;">

          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages185') }}</td>
            <td class="td_right">{{ Information.UserName }}</td>
          </tr>

          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages71') }}</td>
            <td class="td_right">{{ Information.StartTime }}</td>
          </tr>

          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages186') }}</td>
            <td class="td_right">{{ Information.EndTime }}</td>
          </tr>

          <tr style="height: 30px;">
            <td class="td_left">{{ $t('original.languages187') }}</td>

            <td class="td_right">

       


              <div v-if="appointmentList.length > 0">
                <div v-for="item in appointmentList" :key="item.index">
                  <span>{{ item.RealName }}</span>
                  <span style="margin-left: 20px;">{{ item.SchedulDate }}</span>
                </div>
              </div>


              <div v-else>
                 {{ $t('original.languages188') }}
              </div>
            </td>
          </tr>

          <tr style="height: 30px;">
            <td class="td_left"> {{ $t('original.languages189') }}：</td>
            <td class="td_right">
              {{
                Information.LeaveReason == ''
                  ? '未填写请假原因'
                  : Information.LeaveReason
              }}
            </td>
          </tr>
        </table>

        <table style="margin-top=20px; width:100%">
          <tr style="height: 30px;">
            <td class="td_left">
               {{ $t('original.languages190') }}
            </td>
            <td
              class="td_right"
              :style="
                Information.Status == 0
                  ? 'color: rgba(0, 136, 255, 1);'
                  : Information.Status == -1
                  ? 'color: rgba(242, 75, 78, 1);'
                  : Information.Status == 1
                  ? 'color: rgba(21, 191, 109, 1); '
                  : 'color: rgba(141, 141, 141, 1);'
              "
            >
              {{
                Information.Status == 0
                  ? '待审批'
                  : Information.Status == -1
                  ? '已拒绝'
                  : Information.Status == 1
                  ? '已同意'
                  : '已撤销'
              }}
            </td>
          </tr>
           
          <tr style="height: 30px;" v-if="Information.Status == -1 && Information.Isshow">
            <td class="td_left">{{ $t('original.languages191') }}</td>
            <td class="td_right">{{ Information.AefuseCause }}</td>
          </tr>
          <tr style="height: 30px;"
            v-if="
              (Information.Status == -1 || Information.Status == 1) &&
              Information.Isshow
            "
          >
            <td class="td_left"> {{ $t('original.languages192') }}</td>
            <td class="td_right">{{ Information.Approver }}</td>
          </tr>

          <tr style="height: 30px;"
            v-if="
              (Information.Status == -1 || Information.Status == 1) &&
              Information.Isshow
            "
          >
            <td class="td_left">{{ $t('original.languages193') }}</td>
            <td class="td_right">{{ Information.ApproverTime }}</td>
          </tr>

          <tr style="height: 30px;" v-if="Information.Status == 0">
            <td class="td_left">{{ $t('original.languages194') }}</td>
            <td class="td_right">
              <el-input
                :placeholder="$t('original.languages194')"
                type="textarea"
                v-model="Information.AefuseCause"
              ></el-input>
            </td>
          </tr>
        </table>

        <div class="buttons"  style="width: 100%;"  v-if="Information.Status == 0">
          <el-button  type="primary" :loading="UpdateStatusload"
            @click="UpdateStatus((Information.Status = -1), Information.LeaveID)">
             {{ $t('original.languages195') }}
          </el-button>
          <el-button type="primary" :loading="UpdateStatusload" @click="UpdateStatus((Information.Status = 1), Information.LeaveID)">
             {{ $t('original.languages196') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-tabs type="border-card" class="list-cnt">
      <el-tab-pane :label="$t('original.languages197')">
        <span slot="label">{{ $t('original.languages197') }}</span>
        <el-table
          :data="UndoTableData"
          v-loading="IsDataLoad"
          element-loading-text="拼命加载中..."
        >
          <el-table-column :label="$t('original.The_serial_number')" width="100px">
            <template slot-scope="scope">
              {{ (pageUndoIndex - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="UserName" :label="$t('original.name')"></el-table-column>

          <el-table-column prop="Phone" :label="$t('original.phone')"></el-table-column>

          <el-table-column
            prop="StartTime"
            :label="$t('original.languages198')"
          ></el-table-column>

          <el-table-column prop="EndTime" :label="$t('original.languages199')"></el-table-column>
          <el-table-column prop="LeaveReason" :label="$t('original.languages189')"></el-table-column>

          <el-table-column :label="$t('original.languages190')" width="100">
            <template>
              <span class="state-blue" style="color: #fff;background-color: rgba(0, 136, 255, 1);padding: 8px;border-radius: 12px;">
                 {{ $t('original.languages200') }}
              </span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('original.languages49')" width="100" align="center">
            <template slot-scope="scope">
              <span class="option-blue copy_Button" @click="handleCheck(scope.row)
                  Information.Isshow = false" >
                 {{ $t('original.languages201') }}
              </span>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination style="margin-top: 20px; text-align: right;"  @current-change="handleUndoCurrentChange" :current-page.sync="pageUndoIndex" :page-size="pageUndoSize" layout="total, prev, pager, next" :total="UndoCount" v-if="UndoCount > 0"></el-pagination>
      </el-tab-pane>

      <el-tab-pane :label="$t('original.languages202')">
        <el-table  :data="DoTableData"  v-loading="IsDataLoad" element-loading-text="拼命加载中...">
          <el-table-column :label="$t('original.The_serial_number')" width="100px">
            <template slot-scope="scope">
              {{ (pageDoIndex - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column prop="UserName" :label="$t('original.name')"></el-table-column>

          <el-table-column prop="Phone" :label="$t('original.phone')"></el-table-column>

          <el-table-column prop="StartTime" :label="$t('original.languages198')"></el-table-column>

          <el-table-column  prop="EndTime"  :label="$t('original.languages199')"></el-table-column>

          <el-table-column  prop="LeaveReason"  :label="$t('original.languages189')"></el-table-column>

          <!-- -1表示被拒绝，1表示同意请假，-2已撤销 -->
          <el-table-column :label="$t('original.languages190')" width="100">
            <template slot-scope="scope">
              <span class="state-green" v-if="scope.row.Status == 1"  style="color: #fff; background-color: rgba(21, 191, 109, 1);padding: 8px;border-radius: 12px;">
                已同意
              </span>
              <span class="state-red" v-else-if="scope.row.Status == -1" style="color: #fff;background-color: rgba(242, 75, 78, 1);padding: 8px;border-radius: 12px;">
                已拒绝
              </span>
              <span class="state-gray" v-else>
                已撤销
              </span>
            </template>

          </el-table-column>

          <el-table-column :label="$t('original.languages49')" width="100">
            <template slot-scope="scope">
              <span  class="option-blue copy_Button"  @click="handleCheck(scope.row)
              Information.Isshow = true">
                 {{ $t('original.languages174') }}
              </span>
              <span class="w" @click="chehui(scope.row)" v-if="getFullName(scope.row.EndTime,scope.row.Status)" >撤回</span>
            </template>
          </el-table-column>
        </el-table>
        
        <el-pagination style="margin-top: 20px; text-align: right;" @current-change="handleDoCurrentChange" :current-page.sync="pageDoIndex" :page-size="pageDoSize" layout="total, prev, pager, next" :total="DoCount" v-if="DoCount > 0"></el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogTableVisible: false, //打开详情框
      pageUndoSize: 10,
      pageUndoIndex: 1,
      pageDoSize: 10,
      pageDoIndex: 1,
      UndoTableData: [],
      DoTableData: [],
      UndoCount: -1,
      DoCount: -1,
      appointmentList: [],
      IsDataLoad: true,
      Information: {
        EndTime: '',
        LeaveID: '',
        LeaveReason: '',
        StartTime: '',
        Status: '',
        UserAccount: '',
        UserName: '',
        UserAccount: '',
        AefuseCause: '',
        Approver: '',
        ApproverTime: '',
        Isshow: false,
      },
      UpdateStatusload:false,
    }
  },
  created() {
    this.GetData();
  },
  methods: {
    getFullName(endtime,Status){
      if(Status == 1){
        var daynian = Number(this.newDatefun(new Date()).substring(0, 4)) 
        var dayyue = Number(this.newDatefun(new Date()).substring(5, 7)) 
        var dayri = Number(this.newDatefun(new Date()).substring(8, 10)) 
        var endnian = Number(this.newDatefun(new Date(endtime)).substring(0, 4)) 
        var endyue = Number(this.newDatefun(new Date(endtime)).substring(5, 7)) 
        var endri = Number(this.newDatefun(new Date(endtime)).substring(8, 10)) 
        if(endnian >= daynian){
          if(endyue > dayyue){
            return true
          }else if(endyue == dayyue){
            if(endri>dayri){
              return true
            }else{
              return false
            }
          }else if(endyue < dayyue){
            return false
          }
        }else{
          return false
        }
      }else{
        return false
      }
    },
    GetData() {
      this.IsDataLoad = true;
      let _this = this;
      this.$Http_Post('ConsultSubscribe/GetAllExamineLeave', {
        pageSize: this.pageUndoSize,
        pageIndex: this.pageUndoIndex,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.UndoTableData = res.Data.UndoTableData;
          _this.DoTableData = res.Data.DoTableData;
          _this.UndoCount = res.Data.UndoCount;
          _this.DoCount = res.Data.DoCount;
          _this.IsDataLoad = false;
          _this.$parent.RefreshLeaveCount(_this.UndoCount);
        }
      })
    },
    GetUndoData() {
      
      this.IsDataLoad = true;
      let _this = this;
      this.$Http_Post('ConsultSubscribe/GetUndoExamineLeave', {
        pageSize: this.pageUndoSize,
        pageIndex: this.pageUndoIndex,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.UndoTableData = res.Data.UndoTableData;
          _this.UndoCount = res.Data.UndoCount;
          _this.IsDataLoad = false;
          _this.$parent.RefreshLeaveCount(_this.UndoCount);
        }
      })
    },
    GetDoData() {
      this.IsDataLoad = true;
      let _this = this;
      this.$Http_Post('ConsultSubscribe/GetDoExamineLeave', {
        pageSize: this.pageDoSize,
        pageIndex: this.pageDoIndex,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.DoTableData = res.Data.DoTableData;
          _this.DoCount = res.Data.DoCount;
          _this.IsDataLoad = false;
        }
      })
    },
    handleUndoCurrentChange(val) {
      this.pageUndoIndex = val;
      this.GetUndoData();
    },
    handleDoCurrentChange(val) {
      this.pageDoIndex = val;
      this.GetDoData();
    },
    newDatefun(time) {
      var date = new Date(time)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      return y + '-' + m + '-' + d
    },
    chehui(obj){

      




      this.$Http_Post('ConsultSubscribe/UpdateCounselorLeave', {
        LeaveID: obj.LeaveID,
        Status: '-2',
        AefuseCause: obj.AefuseCause,
      }).then((res) => {

        if (res.Code == 200 || res.Code == 0) { 
          this.Global.request_successful(res.Message);
          this.GetDoData()
        } else {
          this.$message.error(this.$t('original.languages206'));
        }

      })
    },
    handleCheck(obj) {
      let _this = this;
      _this.dialogTableVisible = true;
      _this.Information.EndTime = obj.EndTime;
      _this.Information.LeaveID = obj.LeaveID;
      _this.Information.LeaveReason = obj.LeaveReason;
      _this.Information.StartTime = obj.StartTime;
      _this.Information.Status = obj.Status;
      _this.Information.UserAccount = obj.UserAccount;
      _this.Information.UserName = obj.UserName;
      _this.Information.ApproverTime = obj.ApproverTime;
      _this.Information.Approver = obj.Approver;
      _this.Information.AefuseCause = obj.AefuseCause;

      _this.selectappointment(
        _this.Information.StartTime,
        _this.Information.EndTime,
        _this.Information.UserAccount,
      )
      
    },

    selectappointment(starTime, endTime, UserAccount) {
      this.$Http_Post('ConsultSubscribe/GetLeaveAppointment', { StartTime: starTime, EndTime: endTime,UserID: UserAccount}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.appointmentList = res.Data;
        } else {
          this.$notify.closeAll()
          this.$notify.error({
            title: this.$t('original.languages168'),
            // title: '错误',
            message: res.data.Message,
          })
        }
      })
    },

    UpdateStatus(Status, LeaveID) {
      let AefuseCause = '';
      if (Status == -1) {
        AefuseCause = this.Information.AefuseCause;
      }
      this.UpdateStatusload=true;
      this.$Http_Post('ConsultSubscribe/UpdateCounselorLeave', {
        LeaveID: LeaveID,
        Status: Status,
        AefuseCause: AefuseCause,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) { 
          if (Status == -1) {
            this.$message({
              message: this.$t('original.languages204'),
              type: 'success',
            })
          } else {
            this.$message({
              message: this.$t('original.languages203'),
              type: 'success',
            })
          }
          this.GetUndoData();
          this.GetDoData();
          this.dialogTableVisible = false;
        } else {
          this.$message.error(this.$t('original.languages206'));
        }
        this.UpdateStatusload=false;
      })
    },
  },
}
</script>
<style>
.el-tabs {height: 100%;}
.list-cnt {height: 100%;}
.el-table--enable-row-transition .el-table__body td{text-align: center;}
</style>
